import { memo } from 'react';

import AddActionButton from './AddActionButton';

function AddRuleComponent({ handleOnClick }) {
  return <AddActionButton handleOnClick={handleOnClick}>Add condition</AddActionButton>;
}

export default memo(AddRuleComponent);
